export default __webpack_public_path__ + "icon-public.f317ffdd.png";